import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { siteApi } from "../api";

const Ctx = createContext(null);
export const useSite = () => useContext(Ctx);

export function SiteProvider({ children }) {
  const [content, setContent] = useState(null);
  const [error, setError] = useState(false);
  const load = useCallback(async () => {
    try { const r = await siteApi.get("/website/content"); setContent(r.data); setError(false); }
    catch { setError(true); }
  }, []);
  useEffect(() => { load(); }, [load]);
  return <Ctx.Provider value={{ content, error, reload: load }}>{children}</Ctx.Provider>;
}
